// removed by extract-text-webpack-plugin
module.exports = {"AgeGate":"AgeGate-AgeGate","Form":"AgeGate-Form","Logo":"AgeGate-Logo","DateSelect":"AgeGate-DateSelect","CookiePolicy":"AgeGate-CookiePolicy","Lockout":"AgeGate-Lockout","Message":"AgeGate-Message","layout":"AgeGate-layout","GdprConsentContainer":"AgeGate-GdprConsentContainer","GdprConsentCheckbox":"AgeGate-GdprConsentCheckbox","GdprConsentMessage":"AgeGate-GdprConsentMessage","AgeGateCookiePolicy":"AgeGate-AgeGateCookiePolicy"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/theme/rlink-agegate/AgeGate.less
// module id = 138
// module chunks = 0